import { useQuery } from "@tanstack/react-query";

import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";
import { BRAND_LIST_QUERY_KEY } from "../constants/";
import { BackednResponse } from "@shared/lib/types";
import { BrandService } from "../services/brand.service";

export function useGetBrandPermissionsConst() {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<string[]>
  >({
    queryKey: [...BRAND_LIST_QUERY_KEY, "perms"],
    queryFn: () => BrandService.getBrandPermissionsConst(),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    brandPermissions: data?.data || [],
    isError,
    isFetching: isLoading,
  };
}
